// extracted by mini-css-extract-plugin
export default {"dashboard_wrap":"dashboardListing_dashboard_wrap__NZvp5"};